.hr {
  margin: var(--spacingLg) 0;
  border: 0;
  border-bottom: 1px solid var(--paletteBlue0);
  opacity: 0.1;

  &.noMargin {
    margin: 0;
  }
}
